import type { MetaFunction } from "@remix-run/node";
import { NavLink, Outlet } from "@remix-run/react";
import type { SitemapFunction } from "remix-sitemap";

import { ErrorComponent } from "~/components/error-boundary";
import { PageContainer } from "~/components/ui/layout/page-container";
import { Wrapper } from "~/components/ui/layout/wrapper";
import { PageHeading } from "~/components/ui/page-heading";
import { glossaryData } from "~/config/glossary";
import { cn } from "~/utils/classnames";
import { getSeoMeta } from "~/utils/seo";

export const sitemap: SitemapFunction = () => ({
  exclude: true,
});

export const meta: MetaFunction = (metaArgs) => {
  return getSeoMeta(metaArgs, {
    title: "Glossaire du photovoltaique et de l'énergie solaire",
    description: `POwR Connect vous propose un lexique sur les notions clés du photovoltaïque et de l'énergie solaire.`,
  });
};

const GlossaryLayout = () => {
  const letters = glossaryData
    .map((item) =>
      item.word[0]
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    )
    .filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

  const breadcrumbData = [
    {
      name: "Glossaire",
      slug: "/",
    },
  ];

  return (
    <PageContainer>
      <PageHeading
        breadcrumbData={breadcrumbData}
        headingText="Glossaire du photovoltaique et de l'énergie solaire"
      />
      <Wrapper className="mb-12">
        <p className="mb-12">
          POwR Connect vous propose son glossaire sur les notions clés du photovoltaïque et de
          l&apos;énergie solaire.
        </p>
        <nav
          className="mx-auto mb-12 flex flex-wrap items-center"
          aria-label="Navigation dans les lettres du glossaire"
        >
          {letters && letters.length > 0
            ? letters.map((letter) =>
                typeof letter === "string" ? (
                  <NavLink
                    to={`/glossaire/${letter}`}
                    className={({ isActive }) =>
                      cn(
                        "p-2 text-lg font-medium text-grey-500 hover:text-grey-900",
                        isActive && "text-primary underline underline-offset-2"
                      )
                    }
                    key={letter}
                  >
                    {letter.toUpperCase()}
                  </NavLink>
                ) : null
              )
            : null}
        </nav>
        <Outlet />
      </Wrapper>
    </PageContainer>
  );
};

export default GlossaryLayout;

export const ErrorBoundary = () => {
  return <ErrorComponent />;
};
